export default __webpack_public_path__ + "static/media/splash_animation.4c9c6156.mp4";